import { ReactNode } from 'react'

export function ItemField({
  label,
  children,
}: {
  label: string
  children: ReactNode
}) {
  return (
    <div>
      <div className="text-xs text-muted-foreground">{label}</div>
      {children}
    </div>
  )
}
